import { useMemo } from 'react';
import { Chip } from '../../../../components/common/chip/Chip';
import { SvgFileNameType } from '../../../../interfaces/Element.interfaces';

interface ProductChipProps {
  type: 'PLUVA' | 'PARTNER' | 'NEW';
}

interface IChipConfig {
  iconFileName: SvgFileNameType;
  color: 'primary' | 'quaternary' | 'secondary';
  title: string;
}

interface IProductChipConfig {
  PLUVA: IChipConfig;
  PARTNER: IChipConfig;
  NEW: IChipConfig;
}

const productChipConfigs: IProductChipConfig = {
  PLUVA: {
    iconFileName: 'BadgeCheck',
    color: 'primary',
    title: '플루바',
  },
  PARTNER: {
    iconFileName: 'CircleHeart',
    color: 'quaternary',
    title: '파트너',
  },
  NEW: {
    iconFileName: 'CircleNew',
    color: 'secondary',
    title: '신규',
  },
};

export const ProductChip = ({ type }: ProductChipProps) => {
  const CurrentProductChip = useMemo<JSX.Element>(() => {
    if (!type) {
      return <></>;
    }

    return (
      <Chip
        type={'square'}
        icon={{ name: productChipConfigs[type].iconFileName, size: 'Large', position: 'left', fill: '#FFFFFF' }}
        theme="strong"
        color={productChipConfigs[type].color}
        size={'lg'}
      >
        {productChipConfigs[type].title}
      </Chip>
    );
  }, [type]);

  return CurrentProductChip;
};
